import { faWindowClose } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fabric from 'office-ui-fabric-react';
import React, { FC, useEffect, useState } from 'react';
import { absoluteContainer, closeIcon } from '../Helpers';

interface CustomDropListProps {
    items: { id: number; name: string | null }[];
    selectItem(item: any): void;
    placeholder: string;
}

export const CustomDropList: FC<CustomDropListProps> = (props: CustomDropListProps) => {
    const [searchItem, setSearchItem] = useState('');
    const [itemSelected, setItemSelected] = useState(false);
    const [itemMenuShow, setItemMenuShow] = useState(false);

    useEffect(() => {}, []);

    const filteredItems = () => {
        return props.items.filter((x: any) => x.name.toLowerCase().indexOf(searchItem.toLowerCase()) > -1);
    };

    const openList = () => {
        setSearchItem('');
        setItemSelected(false);
        if (itemMenuShow) {
            setItemMenuShow(false);
        } else {
            setItemMenuShow(true);
        }
    };

    return (
        <fabric.Stack style={{ justifyContent: 'space-between' }} horizontal verticalAlign="center">
            <fabric.Stack style={{ position: 'relative' }}>
                <fabric.TextField
                    className={'dropdownColor'}
                    value={searchItem}
                    placeholder={props.placeholder}
                    onChange={(e: any, item) => {
                        setItemMenuShow(true);
                        setSearchItem((e.target as any).value);
                    }}
                    autoComplete="off"
                    onClick={(e: any) => openList()}
                    styles={{
                        root: {
                            justifyContent: 'center',
                            maxWidth: 250,
                            width: 250,
                            minWidth: 160
                        }
                    }}
                />
                <fabric.Link styles={closeIcon} onClick={() => openList()}>
                    {itemMenuShow ? (
                        <FontAwesomeIcon icon={faWindowClose} style={{ color: '#4A9491' }} />
                    ) : (
                        <i className="ms-Dropdown-caretDown" style={{ marginRight: '2px' }}>
                            
                        </i>
                    )}
                </fabric.Link>
                {props.items && itemMenuShow && !itemSelected && (
                    <fabric.Stack horizontal styles={absoluteContainer}>
                        <fabric.Stack styles={{ root: { display: 'inline-flex', maxHeight: '100px' } }}>
                            {filteredItems().map((x: { id: number; name: string | null }) => (
                                <fabric.Link
                                    key={x.id}
                                    onClick={e => {
                                        props.selectItem(x);
                                        setSearchItem(x.name!);
                                        setItemSelected(true);
                                    }}
                                    style={{
                                        padding: 5,
                                        borderRadius: 90,
                                        color: '#4A9491'
                                    }}
                                >
                                    {x.name}
                                </fabric.Link>
                            ))}
                        </fabric.Stack>
                    </fabric.Stack>
                )}
            </fabric.Stack>
        </fabric.Stack>
    );
};
